/**
 * Session time as m:ss, for anything that points a human at a moment in a sit.
 *
 * Splitting first and rounding second is wrong: at 2699.9996 s `Math.floor` leaves
 * 59.9996 s in the seconds field and `toFixed` rounds it up, printing 44:60.00 for what is
 * really 45:00.00. The diagnostics screen and the QA analyser both did this, and a
 * timestamp that names a minute that does not exist sends you to the wrong place in the
 * audio. Round to the printed precision first, then split.
 */
export function clock(sec: number | null, decimals = 2): string {
  if (sec == null || !Number.isFinite(sec)) return '—';
  const scale = 10 ** decimals;
  const ticks = Math.round(Math.max(0, sec) * scale);
  const minutes = Math.floor(ticks / (60 * scale));
  const rest = (ticks - minutes * 60 * scale) / scale;
  return `${minutes}:${rest.toFixed(decimals).padStart(decimals ? decimals + 3 : 2, '0')}`;
}
